import { Drawer, IconButton, Stack, SvgIcon, Typography } from '@mui/material'
import { IconX } from '@tabler/icons-react'
import { ReactNode } from 'react'

type SimpleDrawerProps = {
  children: ReactNode
  title: string
  open: boolean
  onClose: () => void
  icon?: ReactNode
}

export const SimpleDrawer = ({ children, title, icon, open, onClose }: SimpleDrawerProps) => {
  return (
    <Drawer
      open={open}
      onClose={onClose}
      slotProps={{ paper: { sx: { width: 'min(600px, 100%)', height: 1, overflow: 'hidden' } } }}
    >
      <Stack p={3} gap={2} flex={1} overflow="hidden">
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="row" spacing={1} useFlexGap sx={{ alignItems: 'center' }}>
            {icon}
            <Typography variant="h6">{title}</Typography>
          </Stack>
          <IconButton onClick={onClose}>
            <SvgIcon fontSize="small">
              <IconX />
            </SvgIcon>
          </IconButton>
        </Stack>
        <Stack flex={1} overflow="hidden">
          {children}
        </Stack>
      </Stack>
    </Drawer>
  )
}
